import { gql } from 'graphql-tag';

export const resourceSkillDetailsFragment = gql`
  fragment ResourceSkillDetailsFragment on ResourceSkillDetails {
    category {
      id
      uri
      displayText
    }
    skillAssignments {
      id
      uri
      displayText
      certificate
      skillLevel {
        id
        uri
        displayText
        rating
      }
      skillCustomMetadata {
        uri
        displayText
        type
        text
        date
        number
      }
    }
  }
`;

const resourceSkillsFragment = gql`
  fragment ResourceSkillsFragment on ResourceDetails {
    id
    resourceSkill {
      ...ResourceSkillDetailsFragment
    }
  }

  ${resourceSkillDetailsFragment}
`;

export default resourceSkillsFragment;
